var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-list"},[_c('list',{attrs:{"fs":_vm.locationFields,"api":"locations","editLink":"locations","title":"Location"},on:{"deleted":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }